// Gestion des infobulles sur les icônes (mobile)
document.addEventListener("DOMContentLoaded", function () {
  let lastClicked = null;

  document.querySelectorAll('.animated-stories-link').forEach(function (el) {
    el.addEventListener('click', function (e) {
      const tooltip = el.querySelector('.tooltip-bubble');
      if (!tooltip) return;

      const isMobile = window.innerWidth < 768;

      if (isMobile) {
        if (lastClicked === el && tooltip.classList.contains('visible')) {
          return;
        }

        e.preventDefault();
        document.querySelectorAll('.tooltip-bubble').forEach(tip => tip.classList.remove('visible'));
        tooltip.classList.add('visible');
        lastClicked = el;

        setTimeout(() => {
          tooltip.classList.remove('visible');
          lastClicked = null;
        }, 3000);
      }
    });
  });

  // Clic en dehors d’une icône → fermeture des infobulles
  document.addEventListener('click', function (e) {
    const isIcon = e.target.closest('.animated-stories-link');
    if (!isIcon) {
      document.querySelectorAll('.tooltip-bubble.visible').forEach(tip => tip.classList.remove('visible'));
      lastClicked = null;
    }
  });

  // Ajustement du padding top selon la hauteur du header sticky
  function updateMainPadding() {
    const headerGroup = document.querySelector('.header-sticky-group');
    const main = document.querySelector('main');

    if (headerGroup && main) {
      const headerHeight = headerGroup.offsetHeight;
      main.style.paddingTop = headerHeight + 'px';
    }
  }

  window.addEventListener('load', updateMainPadding);
  window.addEventListener('resize', updateMainPadding);
});
